import React, { ReactNode } from 'react'

import styled from 'styled-components'

import {
  Container,
  TitleLabel,
  Label,
  Content,
  SafeAreaTop,
  SideViewContainer,
} from './styles'

const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top-color: ${({ theme }) => theme.colors.headerText};
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  display: inline-block;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`

interface IFormHeaderProps {
  onPressLeft: () => void
  onPressRight: () => void
  leftLabel: string
  title: string
  rightLabel: string
  children: ReactNode
  isRightButtonDisabled?: boolean
  isLoading?: boolean
}

const headerButtonStyle: React.CSSProperties = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  minWidth: 44,
  minHeight: 44,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px 12px',
}

export const FormHeader = ({
  onPressLeft,
  onPressRight,
  leftLabel,
  title,
  rightLabel,
  children,
  isRightButtonDisabled = false,
  isLoading = false,
}: IFormHeaderProps) => (
  <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
    <SafeAreaTop />
    <Container>
      <SideViewContainer>
        <button
          onClick={onPressLeft}
          style={headerButtonStyle}
        >
          <Label>{leftLabel}</Label>
        </button>

        <TitleLabel>{title}</TitleLabel>

        <button
          onClick={onPressRight}
          disabled={isLoading || isRightButtonDisabled}
          style={{
            ...headerButtonStyle,
            cursor: isRightButtonDisabled ? 'not-allowed' : 'pointer',
          }}
        >
          {!isLoading ? (
            <Label $isDisabled={isRightButtonDisabled}>{rightLabel}</Label>
          ) : (
            <Label>
              <LoadingSpinner />
            </Label>
          )}
        </button>
      </SideViewContainer>
    </Container>
    <Content>{children}</Content>
  </div>
)
